import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  BARCODE_TEMPLATE_CREATE_REQUESTED,
  BARCODE_TEMPLATE_CREATE_SUCCESS,
  BARCODE_TEMPLATE_CREATE_FAILURE,
  BARCODE_TEMPLATE_DELETE_REQUESTED,
  BARCODE_TEMPLATE_DELETE_SUCCESS,
  BARCODE_TEMPLATE_DELETE_FAILURE,
  BARCODE_TEMPLATE_INDEX_REQUESTED,
  BARCODE_TEMPLATE_INDEX_SUCCESS,
  BARCODE_TEMPLATE_INDEX_FAILURE,
  BARCODE_TEMPLATE_UPDATE_REQUESTED,
  BARCODE_TEMPLATE_UPDATE_SUCCESS,
  BARCODE_TEMPLATE_UPDATE_FAILURE,
  BARCODE_TEMPLATE_PREVIEW_REQUESTED,
  BARCODE_TEMPLATE_PREVIEW_SUCCESS,
  BARCODE_TEMPLATE_PREVIEW_FAILURE,
  GET_FUNGIBLES_REQUESTED,
  GET_FUNGIBLES_SUCCESS,
  GET_FUNGIBLES_FAILURE,
  GET_LINE_SETTINGS_REQUESTED,
  GET_LINE_SETTINGS_SUCCESS,
  GET_LINE_SETTINGS_FAILURE,
  BARCODE_TEMPLATES_UPGRADE_REQUESTED,
  BARCODE_TEMPLATES_UPGRADE_SUCCESS,
  BARCODE_TEMPLATES_UPGRADE_FAILURE,
} from '../types';

export const createBarcodeTemplateRequested = () => {
  return {
    type: BARCODE_TEMPLATE_CREATE_REQUESTED
  }
};

export const createBarcodeTemplateSuccess = (payload) => {
  return {
    type: BARCODE_TEMPLATE_CREATE_SUCCESS,
    payload: payload
  }
};

export const createBarcodeTemplateFailure = (error) => {
  return {
    type: BARCODE_TEMPLATE_CREATE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const deleteBarcodeTemplateRequested = (payload) => {
  return {
    type: BARCODE_TEMPLATE_DELETE_REQUESTED,
    payload: payload
  }
};

export const deleteBarcodeTemplateSuccess = (payload) => {
  return {
    type: BARCODE_TEMPLATE_DELETE_SUCCESS,
    payload: payload
  }
};

export const deleteBarcodeTemplateFailure = (error) => {
  return {
    type: BARCODE_TEMPLATE_DELETE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const indexBarcodeTemplatesRequested = () => {
  return {
    type: BARCODE_TEMPLATE_INDEX_REQUESTED
  }
};

export const indexBarcodeTemplatesSuccess = (payload) => {
  return {
    type: BARCODE_TEMPLATE_INDEX_SUCCESS,
    payload: payload
  }
};

export const indexBarcodeTemplatesFailure = (error) => {
  return {
    type: BARCODE_TEMPLATE_INDEX_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const updateBarcodeTemplateRequested = () => {
  return {
    type: BARCODE_TEMPLATE_UPDATE_REQUESTED
  }
};

export const updateBarcodeTemplateSuccess = (payload) => {
  return {
    type: BARCODE_TEMPLATE_UPDATE_SUCCESS,
    payload: payload
  }
};

export const updateBarcodeTemplateFailure = (error) => {
  return {
    type: BARCODE_TEMPLATE_UPDATE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};


export const previewBarcodeTemplateRequested = () => {
  return {
    type: BARCODE_TEMPLATE_PREVIEW_REQUESTED,
  }
};

export const previewBarcodeTemplateSuccess = (payload) => {
  return {
    type: BARCODE_TEMPLATE_PREVIEW_SUCCESS,
    payload: payload
  }
};

export const previewBarcodeTemplateFailure = () => {
  return {
    type: BARCODE_TEMPLATE_PREVIEW_FAILURE
  }
};

export const upgradeBarcodeTemplatesRequested = () => {
  return {
    type: BARCODE_TEMPLATES_UPGRADE_REQUESTED
  }
};

export const upgradeBarcodeTemplatesSuccess = (payload) => {
  return {
    type: BARCODE_TEMPLATES_UPGRADE_SUCCESS,
    payload: payload
  }
};

export const upgradeBarcodeTemplatesFailure = (error) => {
  return {
    type: BARCODE_TEMPLATES_UPGRADE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};


export const getFungiblesRequested = () => {
  return {
    type: GET_FUNGIBLES_REQUESTED
  }
};

export const getFungiblesSuccess = (payload) => {
  return {
    type: GET_FUNGIBLES_SUCCESS,
    payload: payload
  }
};

export const getFungiblesFailure = (error) => {
  return {
    type: GET_FUNGIBLES_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const getLineSettingsRequested = () => {
  return {
    type: GET_LINE_SETTINGS_REQUESTED
  }
};

export const getLineSettingsSuccess = (payload) => {
  return {
    type: GET_LINE_SETTINGS_SUCCESS,
    payload: payload
  }
};

export const getLineSettingsFailure = (error) => {
  return {
    type: GET_LINE_SETTINGS_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const indexBarcodeTemplates = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(indexBarcodeTemplatesRequested());

    let endPoint = Config.baseUrl + Config.barcodeTemplate + 's';
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(indexBarcodeTemplatesSuccess(response.data));
      }).catch((error) => {
        dispatch(indexBarcodeTemplatesFailure(error));
      });
  }
}

export const createBarcodeTemplate = (shopUrl, payload, options) => {
  return (dispatch) => {
    dispatch(createBarcodeTemplateRequested());

    let endPoint = Config.baseUrl + Config.barcodeTemplate;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { options: options } , { headers: headers })
      .then((response) => {
        dispatch(createBarcodeTemplateSuccess(response.data));
      }).catch((error) => {
        dispatch(createBarcodeTemplateFailure(error));
      });
  }
}

export const updateBarcodeTemplate = (shopUrl, payload, options) => {
  return (dispatch) => {
    dispatch(updateBarcodeTemplateRequested());

      let endPoint = Config.baseUrl + Config.barcodeTemplate + '/' + Config.update;
      let headers = Object.assign(Config.headers);
      headers.payload = payload;
      headers.shop = shopUrl;

      return Axios.post(endPoint, { options: options } , { headers: headers })
        .then((response) => {
          dispatch(updateBarcodeTemplateSuccess(response.data));
        })
        .catch((error) => {
          dispatch(updateBarcodeTemplateFailure(error));
        });
  }
}

export const previewBarcodeTemplate = (shopUrl, payload, options, values) => {
  return (dispatch) => {
    dispatch(previewBarcodeTemplateRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.preview;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { options: options, values: values } , { headers: headers })
      .then((response) => {
        dispatch(previewBarcodeTemplateSuccess(response.data));
      }).catch((error) => {
        dispatch(previewBarcodeTemplateFailure());
      });
  }
}

export const deleteBarcodeTemplate = (shopUrl, payload, uuid) => {
  return (dispatch) => {
    dispatch(deleteBarcodeTemplateRequested(uuid));

    let endPoint = Config.baseUrl + Config.barcodeTemplate + '/' + Config.delete;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { uuid: uuid } , { headers: headers })
      .then((response) => {
        dispatch(deleteBarcodeTemplateSuccess(response.data));
      }).catch((error) => {
        dispatch(deleteBarcodeTemplateFailure(error));
      });
  }
}

export const getTemplateFungibles = (shopUrl, payload, uuid) => {
  return (dispatch) => {
    dispatch(getFungiblesRequested());

    let endPoint = Config.baseUrl + Config.fungibles + '/' + uuid;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;
    
    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(getFungiblesSuccess(response.data));
      }).catch((error) => {
        dispatch(getFungiblesFailure(error));
      });
  }
}

export const getTemplateLineSettings = (shopUrl, payload, uuid) => {
  return (dispatch) => {
    dispatch(getLineSettingsRequested());

    let endPoint = Config.baseUrl + Config.lineSettings + '/' + uuid;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(getLineSettingsSuccess(response.data));
      }).catch((error) => {
        dispatch(getLineSettingsFailure(error));
      });
  }
}

export const upgradeTemplates = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(upgradeBarcodeTemplatesRequested());

    let endPoint = Config.baseUrl + Config.barcodeTemplate + '/' + Config.upgrade;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(upgradeBarcodeTemplatesSuccess(response.data));
      }).catch((error) => {
        dispatch(upgradeBarcodeTemplatesFailure(error));
      });
  }
}
